import * as angular from "angular";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class SubTasksAlertsService {

  /* @ngInject */
  constructor(private bringozToastService: BringozToastService) {
  }

  // CREATE //
  createTemplateSuccess() {
    const message = {
      body: 'SUB_TASKS_CREATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createTemplateError() {
    const message = {
      body: 'SUB_TASKS_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE //
  updateTemplateSuccess() {
    const message = {
      body: 'SUB_TASKS_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateTemplateError() {
    const message = {
      body: 'SUB_TASKS_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // DELETE //
  deleteTemplateSuccess() {
    const message = {
      body: 'SUB_TASKS_DELETE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  deleteTemplateError() {
    const message = {
      body: 'SUB_TASKS_DELETE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  getTemplateError() {
    const message = {
      body: 'SUB_GET_TEMPLATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

}

angular
  .module('bringoz.admin.sub-tasks')
  .service('subTasksAlertsService', SubTasksAlertsService);
